// Two live paths were built against /memory before the plan moved to /agent (the account), and
// both are baked into software already installed: the agent's 429 sends people to
// ASSERTION_UPGRADE_URL (…/memory?upgrade=1, packages/opencode/src/session/retry.ts), and a
// Stripe checkout started before the move returns to …/memory?checkout=success. /memory hands
// both on, carrying only the params the account page reads — never ?tab= or ?space=, which are
// /memory's own. /agent and /agent/account still resolve (redirects in app.js) for links already out there.
export const ACCOUNT_PATH = "/account";
const CARRIED = ["upgrade", "checkout"];

export function accountRedirectFor(search) {
  const sp = new URLSearchParams(search || "");
  const out = new URLSearchParams();
  for (const k of CARRIED) {
    const v = sp.get(k);
    if (v != null) out.set(k, v);
  }
  const q = out.toString();
  return q ? `${ACCOUNT_PATH}?${q}` : null;
}
